up.compiler('.js-publication_brand_color', element => {
  for (const [name, value] of Object.entries(JSON.parse(element.dataset.variables))) {
    document.documentElement.style.setProperty(name, value)
  }
})
